import React, { useState, useMemo, useEffect } from 'react';
import './mini.css';
import axios from 'axios';
import correct from "./icons/correct.png"
import wrong from "./icons/wrong.png";
import Pagination from './Pagination';
import { API_ENDPOINTS } from './config/api.config';

let PageSize = 5;

function History() {
  const [currentPage, setCurrentPage] = useState(1);
  const [fetchedData, setFetchedData] = useState([]);
  const formatDate = (timestamp) => {
    const options = {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
      timeZone: 'UTC'
    };

    const formattedDate = new Date(timestamp).toLocaleString('en-US', options);
    return formattedDate;
  };
  useEffect(() => {
    axios.get(API_ENDPOINTS.UPLOAD_HISTORY)
      .then((response) => {
        setFetchedData(response.data);
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      });
  }, []);


  const replaceValueWithIndicator = (value) => {
    if (value === true) {
      return <img src={correct} alt="correct" />; // Green tick
    } else if (value === false) {
      return <img src={wrong} alt="wrong" />; // Red wrong
    }
    return value;
  };
  const currentTableData = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * PageSize;
    const lastPageIndex = firstPageIndex + PageSize;
    return fetchedData.slice(firstPageIndex, lastPageIndex);
  }, [currentPage, fetchedData]);
  return (
    <div className="history">
      <p className="txt-history">History</p>
      {Array.isArray(currentTableData) && currentTableData.length > 0 ? (
        <table>
            <thead>
              <tr>
                <th>Id</th>
                <th>Created Date</th>
                <th>Uploaded Date</th>
                <th>File Name</th>
                <th>Employee</th>
                <th>File Size</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>

            {currentTableData.map(item => (
              <tr key={item.id}>
                <td>{item.id}</td>
                <td>{formatDate(item.createdAt)}</td>
                <td>{formatDate(item.updatedAt)}</td>
                <td>{item.fileName}</td>
                <td>AJ Anand Robertson</td>
                <td>{item.fileSize}</td>
                <td>{replaceValueWithIndicator(item.isSuccessfullyUploaded)}</td>
              </tr>
            ))}
            </tbody>
          </table>
        ) : (
        <p className='noRecords'>No records found!</p>
      )}
      <Pagination
        className="pagination-bar"
        currentPage={currentPage}
        totalCount={fetchedData.length}
        pageSize={PageSize}
        onPageChange={page => setCurrentPage(page)}
      />
    </div>
  )
}


export default History